import SyncAltOutlined from "@mui/icons-material/SyncAltOutlined";
import { memo } from "react";
import { EditableInfoContainer } from "$components/InfoContainer/EditableInfoContainer";
import { ACTIVITIES_LABELS } from "$utils/typeConstants";

export const ActivitiesBlock = memo(function ActivitiesBlock({
  activities,
  openPopin,
  isDisabled,
}: any) {
  const data = activities
    ?.map((activity: any) => ACTIVITIES_LABELS[activity.name])
    .sort((a1: string, a2: string) => a1.localeCompare(a2))
    .map((a: string) => ({ value: a }));

  return (
    <EditableInfoContainer
      title="Activité(s)"
      icon={<SyncAltOutlined />}
      editButton={{ onClick: openPopin, isDisabled }}
      data={data}
      colData={2}
    />
  );
});
